import { Injectable } from '@angular/core';
import { decode_bbox, GeographicBoundingBox, neighbors } from 'ngeohash';

import { Polygon } from '@connect-services/src/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class GeohashService {
    public findNeighbors(geohashString: string, matrixSize: number): Set<string> {
        if (!(matrixSize & 1) || matrixSize <= 1) {
            throw Error('Wrong matrix size');
        }

        const geohashList = neighbors(geohashString).flatMap((geohash: string): string[] => {
            if (matrixSize - 2 === 1) {
                return [geohash];
            }

            return Array.from(this.findNeighbors(geohash, matrixSize - 2));
        });

        const resultSet = new Set([...geohashList]);
        resultSet.delete(geohashString);

        return resultSet;
    }

    public getGeohashBbox(geohash: string): Polygon {
        const bbox: GeographicBoundingBox = decode_bbox(geohash);

        return {
            coordinates: [
                [
                    [bbox[1], bbox[0]],
                    [bbox[1], bbox[2]],
                    [bbox[3], bbox[2]],
                    [bbox[3], bbox[0]],
                    [bbox[1], bbox[0]],
                ],
            ],
            type: 'Polygon',
        };
    }
}
